var mapboxToGeoJson = require("@mapbox/togeojson"),
    toGeoJson = function toGeoJson(o) {
  var e = new DOMParser().parseFromString(o, "application/xml");
  return mapboxToGeoJson.kml(e);
};

module.exports = {
  toGeoJson: toGeoJson
};